// This Component is creaded to add Delivery address for customer , This is not usinged in signup flow 

import React, { useContext, useEffect, useState } from "react";
import "./AddDeliveryAddress.scss";
import { DeliveryAddressDataContext } from "../../context-api/DeliveryAddressDataProvider";
import GoogleAddressInput from "./GoogleAddressInput";
import InputBox from "../../atomic/inputbox/InputBox";
import SelectBox from "../../atomic/selectbox/SelectBox";
import AtomicButton from "../../atomic/button/AtomicButton";
import { ADD_DELIVERY_SUCCESSFULLY, API_NETWORK_ERROR, ADD_DELIVERYADDRESS_LABEL, DELIVERY_ADDRESS_TITLE, DELIVERY_ADDRESS_SUBTITLE } from "../../global/constants";
import { Alert, AlertTitle } from "@mui/material";
import { isValidZipcodeFormat, isValidAptNo, isFullName } from "./../../utils/validation"
import { localStorageKeys } from "../../global/constants";
import jwt_decode from "jwt-decode";
import { LoginDataContext } from "../../context-api/LoginDataProvider";
import responseErrorMapping from './../../global/error.response.mapping';
import { Error404 } from "../Error404/Error404";
import { isMobile, isDesktop, isIpad } from './../../global/ScreenSizeHelper'
import GetDeliveryAddress from "./GetDeliveryAddress";
import AtomicCheckbox from "../../atomic/Checkbox/AtomicCheckbox";
import variables from "../../global/assets/_variables.scss";

const AddDeliveryAddress = ({ children }) => {
    const [addressErrors, setAddressErrors] = useState(null);
    const [open, setOpen] = useState(false);
    const [invalidMsg, setInvalidMsg] = useState('')
    const [openAddAddress, setOpenAddAddress] = useState(false)
    const [manualEnteredAddress, setManualEnteredAddress] = useState({ addressType: 'Residential' });
    const setManualEnteredAddressHandler = ({ key, value }) => {
        setManualEnteredAddress({ ...manualEnteredAddress, [key]: value });
    };
    const addressTypeOptions = ["Residential", "Apartment", "Office"];
    const {
        showGoogleAddrsesInput,
        googleAddress,
        addDeliveryAddressApiHandler,
        deliverAddressResponse,
        setGoogleAddress,
        setDeliverAddressResponse,
        setGetDeliveryAddressListResponse,
        getDeliveryAddressListResponse,
    } = useContext(DeliveryAddressDataContext);
    const { onLogout, onCustomerInformationApiHandler, customerInfoData } = useContext(LoginDataContext);
    const {
        addressLine,
        city,
        country,
        state,
        description
    } = googleAddress;

    const { isLoading, data, success, errors, errorMessage } = deliverAddressResponse
    const { success: checkSuccess, errorMessage: checkErrorMessage } = getDeliveryAddressListResponse
    const { loading: loadingCheck, data: dataCheck, success: successCheck, errorMessage: errorMessageCheck, noKitchensFound } = customerInfoData


    const { TOKEN } = localStorageKeys;
    const hasTokens = localStorage.getItem(TOKEN);
    const handleClose = () => { setOpen(false); };
    const objectLength = Object.keys(googleAddress).length

    const TriggerCustomerDetailApi = async () => {
        await onCustomerInformationApiHandler()
    }

    const handleOpen = async () => {
        if (!openAddAddress) {
            setOpenAddAddress(true)

        }
        if (openAddAddress) {
            setOpenAddAddress(false)
        }

    }

    useEffect(() => {
        setDeliverAddressResponse({})
    }, [])


    useEffect(() => {

        if (success || success === false) {
            setGoogleAddress({})
            setManualEnteredAddress({ addressType: 'Residential' })
            setOpen(true)

        }
        if (success && hasTokens) {
            TriggerCustomerDetailApi()
        }
        if (success == false && errorMessage === 'Authentication failed!') {
            console.log('------I have to logout --ONE')
            setDeliverAddressResponse({})
            setGetDeliveryAddressListResponse({})
            onLogout()

        }
        if (!hasTokens) {
            console.log('------I have to logout --TWO')
            onLogout()
        }

    }, [success])

    useEffect(() => {
        if (objectLength > 1) {
            setOpen(false)
        }
    }, [googleAddress])

    const decodedToken = jwt_decode(hasTokens);
    const { email } = decodedToken;
    const { addressType = "",
        aptNumber = '',
        zipcode = "",
        full_name = "",
        phone = "", city:
        cityOne = "", state:
        stateOne = "", country:
        countryOne = '', addressLine: addressLineOne = "" } = manualEnteredAddress;
    const hasZipcodeError = !isValidZipcodeFormat(zipcode)
    const hasAptNoError = !isValidAptNo(aptNumber)
    const hasFullNameError = !isFullName(full_name)

    const onChangeHandler = ({ key, event }) => {

        if (event.preventDefault) {
            event.preventDefault();
        }

        if (key === 'addressLine' && !showGoogleAddrsesInput && event.target.value.length <= 10) {
            setManualEnteredAddressHandler({ key, value: event.target.value })

        }


        if (key === 'zipcode') {
            setInvalidMsg("Invalid Zip Entered")
            if (event.target.value.trim().length <= 5) {
                setManualEnteredAddressHandler({ key, value: event.target.value });
            }

        }

        if (key === 'phone' && event.target.value.length <= 10) {
            setManualEnteredAddressHandler({ key, value: event.target.value })

        }

        if (key === 'aptNumber' && event.target.value.length <= 8) {
            setManualEnteredAddressHandler({ key, value: event.target.value })
        }

        if (key === 'full_name' && event.target.value.length <= 50) {
            setManualEnteredAddressHandler({ key, value: event.target.value })
        }

        if (key === 'city' && event.target.value.length <= 20) {
            setManualEnteredAddressHandler({ key, value: event.target.value })
        }

        if ((key === 'state') && event.target.value.length <= 20) {
            setManualEnteredAddressHandler({ key, value: event.target.value })
        }

        if (key === 'country' && event.target.value.length <= 20) {
            setManualEnteredAddressHandler({ key, value: event.target.value })
        }

    };



    const handleSubmit = async () => {
        const {
            addressLine,
            city,
            country,
            state,
            description
        } = googleAddress;
        let formError = {};



        if ((!description && showGoogleAddrsesInput) || (!addressLineOne && !showGoogleAddrsesInput)) {
            formError.address = "Required Address";
        }


        if (!hasFullNameError || full_name.length === 0) {
            formError.full_name = full_name.length === 0 ? "Required Full name" : "Name cannot have Special characters!";
        }


        if (!addressType) {
            formError.addressType = "Required Address Type";
        }
        if (hasAptNoError && aptNumber?.length > 0) {
            formError.aptNumber = "Apt# Special characters not allowed";
        }
        if (!(zipcode && zipcode.length === 5)) {
            formError.zipcode = "Required Zipcode";
        }

        if ((!country && showGoogleAddrsesInput) || (!countryOne && !showGoogleAddrsesInput)) {
            formError.country = "Required Country";
        }


        if ((!state && showGoogleAddrsesInput) || (!stateOne && !showGoogleAddrsesInput)) {
            formError.country = "Required State";
        }


        if ((!city && showGoogleAddrsesInput) || (!cityOne && !showGoogleAddrsesInput)) {
            formError.country = "Required City";
        }


        if (!phone) {
            formError.phone = "Required Phone";
        }


        if (Object.keys(formError).length > 0) {
            setAddressErrors(formError);
        } else {
            setAddressErrors(null);
            const payload = {
                email: email,
                address: showGoogleAddrsesInput ? description : addressLineOne,
                apt_no: aptNumber,
                city: showGoogleAddrsesInput ? city : cityOne,
                state: showGoogleAddrsesInput ? state : stateOne,
                zipcode,
                phone,
                country: showGoogleAddrsesInput ? country : countryOne,
                address_type: addressType,
                full_name,
            };
            payload["isDefault_address"] = true;
            const addressResponse = await addDeliveryAddressApiHandler(payload);

        }
    };


    // We should capture this if block errors in new relic
    if ((checkSuccess == false && checkErrorMessage === API_NETWORK_ERROR)
        || (success == false && errors === true && errorMessage === API_NETWORK_ERROR)
        || (successCheck === false && errorMessageCheck === API_NETWORK_ERROR)
        || (errorMessageCheck?.success === false && errorMessageCheck?.CustomMessage === "Something is seriouly wrong,This is last CATCH block")

    ) {
        return (<Error404 />)
    }


    const onApiErrorAlert = (
        open && <Alert id="alert-box" onClose={handleClose} severity="error" sx={{ width: "385px", border: "solid 1px red", marginBottom: "5px", color: "red" }}>
            {deliverAddressResponse.data?.errors && deliverAddressResponse.data?.errors.map((error, i) => (
                // API response error message is mapped by responseErrorMapping()
                <li key={i}>{responseErrorMapping(error.ErrorMessage)}</li>
            ))}
        </Alert>
    );
    const onSucessAlert = (
        open && <Alert
            id="warning-box"
            severity="success"
            sx={{ width: "386px", border: "solid 2px green", marginBottom: "5px", color: 'green' }}
            onClose={handleClose}
        >{ADD_DELIVERY_SUCCESSFULLY}</Alert>
    );

    const MobileIpadClass = isMobile || isIpad
    const MobileWidthInputbox = '170px';
    const DesktopIpadWidthInputbox = '205px'

    return (
        <>
            <div style={{ margin: '10px 0px 5px 4%' }}> {children}</div>
            <div className={MobileIpadClass ? "delivery-address-title-mobile" : "delivery-address-title-desktop"}>{DELIVERY_ADDRESS_TITLE}</div>
            <div className={MobileIpadClass ? "delivery-address-sub-title-mobile" : "delivery-address-sub-title-desktop"}>{DELIVERY_ADDRESS_SUBTITLE}</div>
            <button className={MobileIpadClass ? "button-style-delivery-address-mobile" : "button-style-delivery-address-desktop"} onClick={handleOpen}> {openAddAddress ? "Cancel   " : "Add address"} </button>
            {!openAddAddress && <GetDeliveryAddress />}


            {openAddAddress && <div className={isMobile ? "Add-deliveryAddress-container-mobile" : `Add-deliveryAddress-container ${isIpad ? "ipad" : ""}`}>
                <div className="add-delivery-address-label">{ADD_DELIVERYADDRESS_LABEL}</div>
                {success === true && onSucessAlert}
                {success === false && onApiErrorAlert}

                {addressErrors !== null && (
                    <Alert
                        severity="error"
                        sx={{ width: "385px", border: "solid 1px red", marginBottom: "5px" }}
                    >
                        <AlertTitle>Error</AlertTitle>

                        <ul>
                            {Object.keys(addressErrors).map((el) => (
                                <li key={el}>
                                    {" "}
                                    {addressErrors[el]}
                                </li>
                            ))}
                        </ul>
                    </Alert>
                )}
                {showGoogleAddrsesInput ? (

                    <GoogleAddressInput
                        styleAutoComplete={{ width: isMobile ? "350px" : '420px', margin: isMobile ? "5px 0px" : "10px" }}
                        error={addressErrors !== null && addressErrors["address"] && addressErrors["address"].length > 0}
                    />

                ) : (
                    <InputBox
                        type="text"
                        label="Enter Address"
                        size="small"
                        sx={{ width: isMobile ? "350px" : "420px", height: "auto", margin: "5px" }}
                        name="apt"
                        value={showGoogleAddrsesInput ? addressLine : addressLineOne}
                        inputErrorMsg=""
                        error={addressErrors !== null && addressErrors["address"] && addressErrors["address"].length > 0}
                        onChange={
                            showGoogleAddrsesInput
                                ? () => { }
                                : (e) => onChangeHandler({ key: "addressLine", event: e })
                        }
                    />

                )
                }
                <InputBox
                    type="text"
                    label="Full Name"
                    size="small"
                    sx={{ width: isMobile ? "350px" : "420px", height: "auto", margin: "5px", margin: "6px 0px 5px 0px" }}
                    name="full_name"
                    value={full_name}
                    //inputProps={{ maxLength: 5 }} work with addul to fix this
                    inputErrorMsg=""
                    error={addressErrors !== null && addressErrors["full_name"] && addressErrors["full_name"].length > 0}
                    onChange={(e) => onChangeHandler({ key: "full_name", event: e })}
                />
                {!showGoogleAddrsesInput &&

                    <>
                        <InputBox
                            type="text"
                            label="Enter City"
                            size="small"
                            sx={{ width: isMobile ? MobileWidthInputbox : DesktopIpadWidthInputbox, height: "auto", margin: "6px 5px 5px 0px" }}
                            name="city"
                            value={showGoogleAddrsesInput ? city : cityOne}
                            inputErrorMsg=""
                            error={addressErrors !== null && addressErrors["city"] && addressErrors["city"].length > 0}
                            onChange={
                                showGoogleAddrsesInput
                                    ? () => { }
                                    : (e) => onChangeHandler({ key: "city", event: e })
                            }
                        />
                        <InputBox
                            type="text"
                            label="Enter State"
                            size="small"
                            sx={{ width: isMobile ? MobileWidthInputbox : DesktopIpadWidthInputbox, height: "auto", margin: "6px 0px 5px 5px" }}
                            name="state"
                            value={showGoogleAddrsesInput ? state : stateOne}
                            inputErrorMsg=""
                            error={addressErrors !== null && addressErrors["state"] && addressErrors["state"].length > 0}
                            onChange={
                                showGoogleAddrsesInput
                                    ? () => { }
                                    : (e) => onChangeHandler({ key: "state", event: e })
                            }
                        /> </>}
                <SelectBox
                    sx={{ width: isMobile ? MobileWidthInputbox : DesktopIpadWidthInputbox, height: "auto", margin: "6px 5px 5px 0px" }}
                    label="Address Type"
                    value={addressType}
                    error={addressErrors !== null && addressErrors["addressType"] && addressErrors["addressType"].length > 0}
                    onChange={(value) =>
                        onChangeHandler({ key: "addressType", event: { target: { value } } })
                    }
                    options={addressTypeOptions}
                />
                <InputBox
                    type="text"
                    label="Enter Apt #"
                    size="small"
                    sx={{ width: isMobile ? MobileWidthInputbox : DesktopIpadWidthInputbox, height: "auto", margin: "6px 0px 5px 5px" }}
                    name="apt"
                    value={aptNumber}
                    //inputProps={{ maxLength: 5 }} work with addul to fix this
                    inputErrorMsg=""
                    error={(hasAptNoError && aptNumber.length > 0) || (addressErrors !== null && addressErrors["aptNumber"] && addressErrors["aptNumber"].length > 0)}
                    onChange={(e) => onChangeHandler({ key: "aptNumber", event: e })}
                />
                <InputBox
                    type="number"
                    label="Enter Zipcode #"
                    size="small"
                    sx={{ width: isMobile ? MobileWidthInputbox : DesktopIpadWidthInputbox, height: "auto", margin: "6px 5px 5px 0px" }}
                    name="zipcode"
                    value={zipcode}
                    error={(invalidMsg.length > 0 && hasZipcodeError) || (addressErrors !== null && addressErrors["zipcode"] && addressErrors["zipcode"].length > 0)}
                    inputErrorMsg={hasZipcodeError ? invalidMsg : ""}
                    onChange={(e) => onChangeHandler({ key: "zipcode", event: e })}
                />

                {!showGoogleAddrsesInput && <InputBox
                    type="text"
                    label="Country"
                    size="small"
                    sx={{ width: isMobile ? MobileWidthInputbox : DesktopIpadWidthInputbox, height: "auto", margin: "6px 0px 5px 5px" }}
                    name="country"
                    value={showGoogleAddrsesInput ? country : countryOne}
                    inputErrorMsg=""
                    error={addressErrors !== null && addressErrors["country"] && addressErrors["country"].length > 0}
                    onChange={
                        showGoogleAddrsesInput
                            ? () => { }
                            : (e) => onChangeHandler({ key: "country", event: e })
                    }
                />}

                <InputBox
                    type="number"
                    label="Phone no"
                    size="small"
                    sx={{ width: isMobile ? MobileWidthInputbox : DesktopIpadWidthInputbox, height: "auto", margin: "6px 0px 5px 5px" }}
                    name="phone"
                    value={phone}
                    inputErrorMsg=""
                    error={addressErrors !== null && addressErrors["phone"] && addressErrors["phone"].length > 0}
                    onChange={(e) => onChangeHandler({ key: "phone", event: e })}
                />

                <div className="inner-container-checkbox">
                    <AtomicCheckbox disabled={true} sx={{ padding: isMobile ? '0' : '0 9px', marginLeft: isMobile ? 0 : 12, color: "lightgrey" }} />
                    <div className="default-checkbox-text"> Set address as default </div>
                </div>

                <AtomicButton
                    label={'Add address'}
                    handleSubmit={handleSubmit}
                    style={{
                        backgroundColor: variables.backgroundDarkBlue,
                        width: isMobile ? "350px" : "422px",
                        marginTop: "15px",
                        marginBottom: "15px",
                        height: '40px'
                    }}
                    loading={isLoading}
                />

                <div style={{ height: '70px', border: '1px solid white', color: 'white' }}> have keep empty space due to footer</div>

            </div>
            }
        </>
    )
}

export default AddDeliveryAddress